import {ReloadButton,} from '@flexinet/ui-components';

import {Box,} from '@mantine/core';

import {useMeters} from '../hooks/useMeters.ts';

// Reload starts again from page 1. It used to call fetchRecords, which loads the NEXT
// page and does nothing once every page is loaded, so it never reloaded.
export const ReloadRecordsButton = () => {

    const {reloadRecords} = useMeters();
    return (
        <Box mx='xs'>
            <ReloadButton onClick={() => reloadRecords()}/>
        </Box>
    );
};
